import { createAction, createReducer, createSlice } from "@reduxjs/toolkit";
import { getallDistributorsACTION, getDistributorACTION, insertUpdateDistributorAction, distributorChangeStatusACTION, distributorDeleteACTION } from "../../actions/distrubutors/distributorsAction";
import { toast } from 'react-toastify';

const INITIAL_STATE = {
    distributors: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    selectedDistributor: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdateDetails: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    activeInactiveDetails: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    deleteDetails: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    }
};

const distributorReducer = createSlice({
    name: "distributor",
    initialState: INITIAL_STATE,
    reducers: {
        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetDistributerDetailsState(state, action) {
            state.selectedDistributor = INITIAL_STATE.selectedDistributor;
            state.insertUpdateDetails = INITIAL_STATE.insertUpdateDetails;
        }
    },
    extraReducers: (builder) => {

        // getallDistributorsACTION start

        builder.addCase(getallDistributorsACTION.fulfilled, (state, action) => {
            state.distributors.data = action.payload.data;
            state.distributors.apiMsg.status = action.meta.requestStatus;
            state.distributors.apiMsg.message = "success";
        });
        builder.addCase(getallDistributorsACTION.pending, (state, action) => {
            state.distributors.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getallDistributorsACTION.rejected, (state, action) => {
            state.distributors.apiMsg.message = action.error.message;
            state.distributors.apiMsg.status = action.meta.requestStatus;
        });


        // getallDistributorsACTION end
        //------------------------------- getDistributorACTION start -------------------------

        builder.addCase(getDistributorACTION.fulfilled, (state, action) => {
            state.selectedDistributor.data = action.payload.data;
            state.selectedDistributor.apiMsg.status = action.meta.requestStatus;
            state.selectedDistributor.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getDistributorACTION.pending, (state, action) => {
            state.selectedDistributor.data = null;
            state.selectedDistributor.apiMsg.message = action.meta.requestStatus;;
            state.selectedDistributor.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getDistributorACTION.rejected, (state, action) => {
            state.selectedDistributor.apiMsg.message = action.error.message;
            state.selectedDistributor.apiMsg.status = action.meta.requestStatus;
        });


        //   getDistributorACTION end

        // insertUpdateDistributorAction start

        builder.addCase(
            insertUpdateDistributorAction.fulfilled,
            (state, action) => {

                state.insertUpdateDetails.data = action.payload.data.data;
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
                state.insertUpdateDetails.apiMsg.message = action.payload.message.message;

                if (!action.payload.newRecord) {
                    let updatedRecord = state.distributors.data.records.map(x => {
                        if (x.id == action.payload.data.data.id) {
                            return action.payload.data.data;
                        }
                        else {
                            return x;
                        }
                    })

                    state.distributors.data.records = updatedRecord;
                }
                else {
                    if (state.distributors.data.records.length) {
                        state.distributors.data.records.unshift(action.payload.data.data);
                    }
                    else {
                        state.distributors.data.records.push(action.payload.data.data);
                    }
                }
                toast.success(action.payload.message.message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "dept-error"
                });
            }
        );
        builder.addCase(
            insertUpdateDistributorAction.pending,
            (state, action) => {
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdateDistributorAction.rejected,
            (state, action) => {

                console.log(action.error.message);
                state.insertUpdateDetails.apiMsg.message = action.error.message;
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "dept-error"
                });
            }
        );

        //   insertUpdateDistributorAction end

        // distributorChangeStatusACTION start

        builder.addCase(distributorChangeStatusACTION.fulfilled, (state, action) => {
            state.distributors.data.records = state.distributors.data.records.map((item) => {

                return {
                    ...item,
                    active: action.payload.id === item.id ? !item.active : item.active
                }
            })
            state.activeInactiveDetails.apiMsg.status = action.meta.requestStatus;
            state.activeInactiveDetails.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(distributorChangeStatusACTION.pending, (state, action) => {
            state.activeInactiveDetails.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(distributorChangeStatusACTION.rejected, (state, action) => {
            state.activeInactiveDetails.apiMsg.message = action.error.message;
            state.activeInactiveDetails.apiMsg.status = action.meta.requestStatus;
        });

        // distributorChangeStatusACTION end


        //------------------------------- distributorDeleteACTION start -------------------------

        builder.addCase(distributorDeleteACTION.fulfilled, (state, action) => {

            state.distributors.data.records = state.distributors.data.records.filter((item, index) => item.id !== action.payload.data.id)

            state.deleteDetails.apiMsg.status = action.meta.requestStatus;
            state.deleteDetails.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(distributorDeleteACTION.pending, (state, action) => {
            state.deleteDetails.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(distributorDeleteACTION.rejected, (state, action) => {
            state.deleteDetails.apiMsg.message = action.error.message;
            state.deleteDetails.apiMsg.status = action.meta.requestStatus;
        });
        //------------------------------- distributorDeleteACTION end -------------------------

    },
});

export const { RESET, ResetDistributerDetailsState } = distributorReducer.actions;
export default distributorReducer.reducer;